<template>
  <div class="col-sm-12">
    <div class="row" id="page-contacts">

      <clearfix :wide="true" :bootstrap="true"></clearfix>

      <div class="col-sm-4">
        <h3>foobar.beer</h3>
        <ul class="footer-list">
          <li><router-link to="/about-foobar">About</router-link></li>
          <li><router-link to="/foobars">Collection</router-link></li>
          <li><router-link to="/privacy-and-license">Privacy &amp; License</router-link></li>
        </ul>
      </div>

      <div class="col-sm-4">
        <h3>friends</h3>
        <ul class="footer-list">
          <li><a href="https://oldtimers-garage.cz">Oldtimers Garage</a></li>
          <li><a href="https://spamalyze.org">Spamalyze</a></li>
        </ul>
      </div>

      <div class="col-sm-4">
        <h3>colleagues</h3>
        <ul class="footer-list">
          <li><a href="https://atdata.com">AtData</a></li>
          <li><a href="https://bouncepilot.com">BouncePilot</a></li>
          <li><a href="https://jpower8.com">jPower8</a></li>
          <li><a href="https://www.thetrask.com">Trask</a></li>
        </ul>
      </div>

      <clearfix></clearfix>
    </div>
  </div>
</template>

<script>
import Clearfix from '@/components/utils/Clearfix'
import ApiCheck from '@/components/utils/ApiCheck'
export default {
  components: {
    Clearfix,
    ApiCheck
  }
}
</script>



// WEBPACK FOOTER //
// FooterMenu.vue?e1a3052c